<template>
  <div>
exhibition-release-new-await
  </div>
</template>

<script>
export default {
  name:  'exhibition-release-new-await',
  data() {
    return {

    }
  },
  components: {

  },
  computed: {

  },
  methods: {

  },
}
</script>

<style scoped lang="scss">

</style>

